import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import LandingPageWrapper from "@iscr/contentful/pages/landing_pages/LandingPageWrapper";
import { useWeightLossSubscriptionMinPrice } from "@iscr/views/ordering/hooks/useWeightLossSubscriptionMinPrice";
import { CTA_ON_CLICK_FUNCTION_IDS } from "@iscr/contentful/components/CTA";
import { showYFPopup } from "@iscr/views/ordering/components/weightLossYoufoodzTOS";
import { showWLTOS } from "@iscr/views/ordering/components/weightLossTOSForm";
import { useExperiment } from "@iscr/xAppLib/Hooks";
import statsig from "@iscr/xAppLib/providers/statsig";
const WeightLossLandingPage = ({ slug }) => {
    const experiment = useExperiment("WL_hide_test");
    const isSelectionPage = slug === "weight-management-selection";
    console.log(experiment, experiment === null || experiment === void 0 ? void 0 : experiment.n);
    useWeightLossSubscriptionMinPrice();
    const preview = app.dev_env;
    const pageSlug = isSelectionPage ? slug : (["both", "Show both"].includes(experiment === null || experiment === void 0 ? void 0 : experiment.n) && "weight-management-program"
        || ["wl1", "WL1 only"].includes(experiment === null || experiment === void 0 ? void 0 : experiment.n) && "weight-management-program-wl1"
        || ["wl2", "WL2 only"].includes(experiment === null || experiment === void 0 ? void 0 : experiment.n) && "weight-management-program-wl2"
        || "weight-management-program");
    const parsedFunctions = useMemo(() => {
        return {
            [CTA_ON_CLICK_FUNCTION_IDS.OPEN_YOUFOODZ_TOS]: showYFPopup,
            [CTA_ON_CLICK_FUNCTION_IDS.OPEN_WL_TOS]: showWLTOS,
        };
    }, []);
    // WL_hide_test: bounce = 1 - n(wl_next_page) / n(wl_page_view)
    const variant = experiment === null || experiment === void 0 ? void 0 : experiment.n;
    useEffect(() => {
        if (isSelectionPage)
            return;
        if (variant)
            statsig.log_event("wl_page_view", null, { variant, slug: pageSlug });
    }, [variant, pageSlug, isSelectionPage]);
    useEffect(() => {
        if (isSelectionPage)
            return;
        const path = window.location.pathname;
        // The router has already moved on by the time the unmount cleanup runs, so location is the next page
        return () => statsig.log_event("wl_next_page", null, { path, next_path: window.location.pathname });
    }, [isSelectionPage]);
    return _jsx(LandingPageWrapper, { slug: pageSlug, preview: preview, parsedFunctions: parsedFunctions }, pageSlug);
};
export default WeightLossLandingPage;
